import { Module } from 'vuex-smart-module';
import ContactsActions from './actions';
import ContactsGetters from './getters';
import ContactsMutations from './mutations';
import ContactsState from './state';

export default new Module({
  state: ContactsState,
  mutations: ContactsMutations,
  actions: ContactsActions,
  getters: ContactsGetters,
});
